import { Button, Link } from '@chakra-ui/react';
import IconMailStar from 'assets/icons/icon-mail-star.svg?react';

interface Props {
  url: string;
}

export default function ButtonEmailPreview({ url }: Props) {
  return (
    <Button 
      ml="auto"
      fontWeight="medium"
      rightIcon={<IconMailStar />}
      as={Link}
      href={url}
      target="_blank"
    >
      Preview do e-mail
    </Button>
  )
}
